// extracted by mini-css-extract-plugin
export var phone = "_3s-0";
export var phoneDragging = "_3s-1";